import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { createPackagingSet } from './createPackagingSet';
import { updatePackagingSet } from './updatePackagingSet';

export const workflows: WorkflowOptions[] = [
  createPackagingSet,
  updatePackagingSet,
  ...Object.values(generateAssetStatusWorkflow('packagingSet')),
];

export default workflows;
